import React from "react";
import { motion, Variants } from "framer-motion";
import "./style.scss";

interface CardProps {
  children: React.ReactNode;
  className?: string;
  animate?: boolean;
  variants?: Variants;
  as?: any;
  href?: string;
  onClick?: () => void;
  [key: string]: any;
}

const Card: React.FC<CardProps> = ({
  children,
  className = "",
  animate = true,
  variants,
  as: Component = "div",
  ...props
}) => {
  const MotionComponent = motion(Component);

  if (!animate) {
    return (
      <Component className={`common-card ${className}`} {...props}>
        {children}
      </Component>
    );
  }

  return (
    <MotionComponent
      className={`common-card ${className}`}
      variants={variants}
      {...props}
    >
      {children}
    </MotionComponent>
  );
};

export default Card;
